import { PermissionsEnum } from '@/auth/interfaces';
import { useColumnsInstalacionesOT } from '@/erp/tecnico/orden-trabajo/shared/hooks';
import {
  EstadosActivacionInstallOTEnumChoice,
  EstadosOrdenTrabajoEnumChoice,
  TABLE_CONSTANTS,
  useCheckPermissions,
  useTableFilter,
  useTableServerSideFiltering,
} from '@/shared';
import { useFetchOrdenTrabajos } from '@/shared/actions/erp';
import {
  GeneralTable,
  LoaderComponent,
  TableTabsScene,
} from '@/shared/components/ui';
import { OrdenTrabajo } from '@/shared/interfaces/erp/tecnico';
import { useUploadImageStore } from '@/store/erp';
import { ActivacionOTCellFotosPending } from '../../../shared/components/tables';

export type FotosSalidaReviewActivacionProps = {};

const FotosSalidaReviewActivacion: React.FC<
  FotosSalidaReviewActivacionProps
> = () => {
  useCheckPermissions(PermissionsEnum.api_view_ordentrabajo);

  ///* global state
  const isUploadingImgs = useUploadImageStore(s => s.isUploading);

  // server side filters - colums table
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,

    // dateBefore,
    // dateAfter,
    onChangeRangeDate,
    cleanFilter,
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  ///* fetch data
  const {
    data: instalacionesAgendadasPagingRes,
    isLoading,
    isRefetching,
  } = useFetchOrdenTrabajos({
    enabled: true,
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      identificacion: searchTerm,
      ...filterObject,
      filterByState: false,
      es_salida:"es_salida",

      // estado_orden_trabajo: EstadoOrdenTrabajoCodigoEnum.EN_ESPERA,
      // estado_imagen_entrada: EstadosImagenChoiceEnum.CARGADO,
      // estado_imagen_salida: EstadosImagenChoiceEnum.CARGADO,
      urls_fotos_salida_isnull: false,
      estado_orden_trabajo_exclude: `${EstadosOrdenTrabajoEnumChoice.PRE_RECHAZADO}`,
      estado_activacion:EstadosActivacionInstallOTEnumChoice.EN_ESPERA,

      // TODO: filter by date
      // fecha_hora_activacion_after: dateAfter,
      // fecha_hora_instalacion_after: dateAfter,
      // fecha_hora_activacion_before: dateBefore,
      // fecha_hora_instalacion_before: dateBefore,
    },
  });

  ///* columns
  const { instalacionesAsignadasTecnicoColumns } = useColumnsInstalacionesOT();

  if (isLoading || isRefetching || isUploadingImgs) return <LoaderComponent />;

  return (
    <TableTabsScene
      globalFilter={globalFilter}
      onChangeFilter={onChangeFilter}
      searchInputText="por identificación de cliente"
      onChangeRangeDate={onChangeRangeDate}
      cleanFilter={cleanFilter}
    >
      <GeneralTable<OrdenTrabajo>
        columns={instalacionesAsignadasTecnicoColumns}
        data={instalacionesAgendadasPagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // filters - server side
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={instalacionesAgendadasPagingRes?.data?.count}
        // // actions
        actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
        // crud
        enableColumnActions={true}
        enableEditing={true}
        onCustomEdit={ordenTrabajo => {
          return (
            <>
              <ActivacionOTCellFotosPending
                ordenTrabajo={ordenTrabajo}
                isReviewingFotosSalida
                canEdit={false}
              />
            </>
          );
        }}
        canDelete={false}
      />
    </TableTabsScene>
  );
};

export default FotosSalidaReviewActivacion;
